import BasicModal from 'components/shared/BasicModal';
import InspectorForm from 'src/pages/authentication/components/inspectorAccount/InspectorForm';
import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import UserPasswordForm from 'src/pages/authentication/components/forgottenPassword/UserPasswordForm';

const InspectorModal = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [resetPasswordState, setResetPasswordState] = useState<string>('');
  const handleOpen = () => setOpen(true);
  const handleClose = (): void => {
    setResetPasswordState('');
    setOpen(false);
  };

  const handleSendPassword = (email: string) => () => {
    setResetPasswordState(email);
  };
  return (
    <>
      <Button
        onClick={handleOpen}
        variant="outlined"
        color="primary"
        size="large"
        sx={{
          width: '90%',
          marginInline: 'auto',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          '@media screen and (max-width: 330px)': {
            fontSize: '12px',
          },
          '&:hover': {
            color: '#0093b3',
            transition: 'all 0.3s ease',
          },
        }}
      >
        Solicitar Clave
      </Button>
      {open && (
        <BasicModal
          open={open}
          handleClose={handleClose}
        >
          {resetPasswordState !== '' ? (
            <UserPasswordForm
              email={resetPasswordState}
              handleClose={handleClose}
            />
          ) : (
            <InspectorForm
              resetPassword={(email, expirationDate) => (
                <>
                  <Typography>
                    <Typography
                      color="textPrimary"
                      variant="h4"
                      marginBottom={5}
                    >
                      Contraseña Activa
                    </Typography>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                      marginTop={2}
                      marginX="auto"
                    >
                      Su contraseña actual se encuentra activa hasta el día
                      <span
                        style={{
                          fontWeight: 500,
                          display: 'inline-block',
                          paddingLeft: '5px',
                        }}
                      >
                        {expirationDate}
                      </span>
                    </Typography>
                  </Typography>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    marginY={2}
                    marginX="auto"
                    textAlign="center"
                    fontWeight={500}
                  >
                    ¿Desea recibir una nueva contraseña a su correo electrónico?
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '10px',
                    }}
                  >
                    <Button
                      id="cancel-button"
                      color="error"
                      fullWidth
                      size="large"
                      type="button"
                      variant="outlined"
                      onClick={handleClose}
                    >
                      Cancelar
                    </Button>
                    <Button
                      id="send-password-button"
                      color="primary"
                      fullWidth
                      size="large"
                      onClick={handleSendPassword(email)}
                      // loading={loading}
                      variant="contained"
                    >
                      Enviar
                    </Button>
                  </Box>
                </>
              )}
            />
          )}
        </BasicModal>
      )}
    </>
  );
};

export default InspectorModal;
